module.exports = __webpack_public_path__ + "img/uniswap.d407a8e8.png";